
export default [
  {
    name:"AnnualReviewApprove",
    path: '/annualReview/approve',
    component: (resolve) => require(['@/views/wellManage/approveAnnual/index'], resolve),
    meta: { title: 'Annual Review', noCache: false, affix: false, checkAccount: true },
    roles:[1]
  },
  {
    name:"AnnualReviewApproveDetail",
    path: '/annualReview/approve/detail',
    component: (resolve) => require(['@/views/wellManage/approveAnnual/details'], resolve),
    hidden:true,
    meta: { title: 'Approval details of Annual Review', noCache: false, affix: false, checkAccount: true },
    roles:[1]
  }
]
